import React from 'react';
import clsx from 'clsx';
import {fade, makeStyles} from '@material-ui/core/styles';
import {isPromoter} from '../../../../Helper/Helper';

export const ROLE_MANAGER = 'manager';
export const ROLE_AGENT = 'agent';
export const ROLE_PROMOTER = 'promoter';
export const ROLE_NONE = 'none';

export const ROLE_HUE = {
    [ROLE_MANAGER]: '#FF4500',
    [ROLE_AGENT]: '#9ACD32',
    [ROLE_PROMOTER]: '#FF9800'
};

export const resolveRoleKey = (roleName, position) => {
    if (isPromoter(position)) return ROLE_PROMOTER;
    if (roleName === 'Manager') return ROLE_MANAGER;
    if (roleName === 'Agent') return ROLE_AGENT;
    return ROLE_NONE;
};

export const roleLabel = (roleKey, roleName, language) => {
    if (roleKey === ROLE_PROMOTER) return language.promoter;
    if (roleKey === ROLE_NONE) return '';
    return roleName;
};

export const getInitials = (name) => {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    const first = parts[0].charAt(0);
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
};

const useStyles = makeStyles((theme) => {
    const solid = (key) => ({
        backgroundColor: ROLE_HUE[key],
        color: key === ROLE_PROMOTER ? '#fff' : theme.palette.text.primary
    });
    return {
        pill: {
            height: 24,
            maxWidth: '100%',
            padding: '0 10px',
            borderRadius: 999,
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            backgroundColor: fade(theme.palette.text.primary, 0.06),
            color: theme.palette.text.secondary
        },
        small: {
            height: 22,
            fontSize: 11,
            padding: '0 8px'
        },
        label: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        avatar: {
            width: 28,
            height: 28,
            borderRadius: '50%',
            flex: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.02em',
            backgroundColor: fade(theme.palette.text.primary, 0.06),
            color: theme.palette.text.secondary
        },
        pillManager: solid(ROLE_MANAGER),
        pillAgent: solid(ROLE_AGENT),
        pillPromoter: solid(ROLE_PROMOTER),
        avatarManager: solid(ROLE_MANAGER),
        avatarAgent: solid(ROLE_AGENT),
        avatarPromoter: solid(ROLE_PROMOTER)
    };
});

const PILL_CLASS = {
    [ROLE_MANAGER]: 'pillManager',
    [ROLE_AGENT]: 'pillAgent',
    [ROLE_PROMOTER]: 'pillPromoter'
};

const AVATAR_CLASS = {
    [ROLE_MANAGER]: 'avatarManager',
    [ROLE_AGENT]: 'avatarAgent',
    [ROLE_PROMOTER]: 'avatarPromoter'
};

export function UserRolePill({roleKey, label, small = false, className}) {
    const classes = useStyles();
    return (
        <span className={clsx(classes.pill, small && classes.small, classes[PILL_CLASS[roleKey]], className)}>
            <span className={classes.label}>{label}</span>
        </span>
    );
}

export function UserAvatar({name, roleKey}) {
    const classes = useStyles();
    return (
        <span className={clsx(classes.avatar, classes[AVATAR_CLASS[roleKey]])} aria-hidden="true">{getInitials(name)}</span>
    );
}

export default UserRolePill;
